import React, {
  ChangeEvent,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import Button from 'kingpin/atoms/Button';

import Row from '../../../Common/Row';
import Label from '../../../V5GadgetForm/Label';
import Inputs from '../../../Inputs';
import { InputWrapper } from '../../../V5GadgetForm/styles';
import FormHeader from '../../../../kingpin/forms/FormHeader';
import Form from '../../../../kingpin/forms/Form';
import FormContent from '../../../../kingpin/forms/FormContent';
import FieldsGrid from '../../../PerformanceBoards/PerformanceBoardSettings/SettingsWizard/BoardFieldsSettings/FieldsGrid/FieldsGrid';
import TextInput from '../../../../kingpin/atoms/TextInput';
import updateBoard from '../../../../api/boards/updateBoard';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';

/**
 * This is hacky transform to get the legacy boards
 * column settings to work with the performance board one
 */
const PerformanceColumnsBridge = ({
  board,
  columnOrder,
}: {
  board: Board;
  columnOrder: { field: string; visible: boolean }[];
}) => {
  const { accountRef } = useContext(AccountPickerContext);
  const [searchText, setSearchText] = useState('');
  const transformedColumnOrder = useMemo((): PerformanceBoardTypes.Column[] => {
    return columnOrder.map((col) => ({
      field: col.field,
      visible: col.visible,
      type: 'field',
      key: col.field,
    }));
  }, [columnOrder]);
  const filteredColumns = useMemo(() => {
    return transformedColumnOrder.filter((f) =>
      f.field.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [searchText, transformedColumnOrder]);
  const updateColumnsOrder = useCallback(
    ({ newOrder }: { newOrder: PerformanceBoardTypes.Column[] }) => {
      const newTransformedOrder = newOrder.map((c) => {
        return {
          field: c.field,
          visible: c.visible,
        };
      });

      const newBoard = {
        ...board,
        columnOrder: newTransformedOrder,
      };

      updateBoard(newBoard, accountRef);
    },
    [accountRef, board],
  );

  return (
    <div>
      <div style={{ marginBottom: '16px', paddingRight: '48px' }}>
        <TextInput
          value={searchText}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setSearchText(event.target.value);
          }}
          placeholder="Search Fields"
          icon="search"
          width="100%"
          autoFocus
        />
      </div>
      <FieldsGrid
        columnOrder={transformedColumnOrder}
        filteredColumns={filteredColumns}
        searchText={searchText}
        updateColumnsOrder={updateColumnsOrder}
      />
    </div>
  );
};

const Columns = ({
  board,
  columnOrder,
  close,
  isSizedToFitOverridden,
  onIsSizedToFitChange,
}: {
  board: Board;
  columnOrder: { field: string; visible: boolean }[];
  close: () => void;
  isSizedToFitOverridden?: boolean;
  onIsSizedToFitChange: (newValue: boolean) => void;
}) => (
  <Form>
    <FormHeader title={'Columns'} onClose={close} />
    <FormContent style={{ overflow: 'hidden' }}>
      <InputWrapper>
        <Label>Is sized to fit</Label>
        <Inputs.Toggle
          value={!!isSizedToFitOverridden}
          onChange={onIsSizedToFitChange}
        />
      </InputWrapper>
      <PerformanceColumnsBridge columnOrder={columnOrder} board={board} />
    </FormContent>
    <Row style={{ justifyContent: 'space-between' }}>
      <Button onClick={close} type="Ghost" size="Small" label="Close" />
    </Row>
  </Form>
);

export default Columns;
